import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ThaiDatePipe } from '@app/shared/thaidate.pipe'
import { HighlightSearchPipe } from '@app/shared/HighlightSearchPipe.pipe'

import { environment } from '@env/environment';
import { CoreModule, HttpService } from '@app/core';
import { RouterModule, Routes } from '../../node_modules/@angular/router';
import { AppComponent } from './app.component';

import { AuthGuard } from '@app/auth.guard';
import { AuthService } from '@app/auth.service';

import { UserService } from '@app/user.service';
import { LocationStrategy, HashLocationStrategy, registerLocaleData } from '@angular/common';
import { LoginComponent } from '@app/account/login/login.component';
import { MainmenuComponent } from './mainmenu/mainmenu.component';

import { UtilService } from './utility/util.service';
import { MasterService } from './utility/master.service';
import { ApiService } from './utility/api.service';
import { NoCacheHeadersInterceptorService } from '@app/no-cache-headers-interceptor.service'

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { MomentModule } from 'angular2-moment'; // optional, provides moment-style pipes for date formatting

import { ContactComponent } from './contact/contact.component';
import { ContactReportComponent } from './contact-report/contact-report.component';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { SocialMediaMonitorComponent } from './social-media-monitor/social-media-monitor.component';
import { ReportComponent } from './report/report.component';
import { SettingComponent } from './setting/setting.component';
import { NewsComponent } from './news/news.component';
import { SideMainMenuComponent } from './side-main-menu/side-main-menu.component';
import { FinancialInstitutionComponent } from './financial-institution/financial-institution.component';
import { SimulatorComponent } from './simulator/simulator.component';
import { RefundComponent } from './refund/refund.component';
import { ContactDpaComponent } from './contact-dpa/contact-dpa.component';
import { QuestionAndAnswerComponent } from './question-and-answer/question-and-answer.component';
import { VerifyComponent } from './verify/verify.component';
import { Verify2Component } from './verify2/verify2.component';
import { IndexComponent } from './index/index.component';
import { AllNewsComponent } from './all-news/all-news.component';
import { RegisterComponent } from './register/register.component';
import { ProfileComponent } from './profile/profile.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { StatusTrackingComponent } from './status-tracking/status-tracking.component';
import { RefundDepositsComponent } from './refund-deposits/refund-deposits.component';
import { JwPaginationComponent } from './jw-pagination/jw-pagination.component';
import { StatusDocumentComponent } from './status-document/status-document.component';
import { LoginSocialComponent } from './login-social/login-social.component';
import { InvestigateComponent } from './investigate/investigate.component';
import { DownloadFileComponent } from './download-file/download-file.component';
import { PagerService } from './pager.service';
import { NotiService } from './noti.service';
import { AboutUsComponent } from './about-us/about-us.component';
import { CryptographyService } from '@app/cryptography.service';
import { TestComponent } from './test/test.component';
import { RequestDocumentComponent } from './request-document/request-document.component';
import { StatusRequestDocumentComponent } from './status-request-document/status-request-document.component';
import { TestndidComponent } from './testndid/testndid.component';
import { SocketioService } from './socketio.service';
import { SinglegatewaywaitComponent } from './singlegatewaywait/singlegatewaywait.component';
import { Testndid2Component } from './testndid2/testndid2.component';
import { Singlegatewaywait2Component } from './singlegatewaywait2/singlegatewaywait2.component';
import { Singlegatewaywait3Component } from './singlegatewaywait3/singlegatewaywait3.component';
const appRoutes: Routes = [
  { path: '', redirectTo: 'mainmenu/index', pathMatch: 'full' },
  {
    path: 'mainmenu', component: MainmenuComponent,
    children: [
      { path: 'refund', component: RefundComponent },
      { path: 'financeInst', component: FinancialInstitutionComponent },
      { path: 'simulate', component: SimulatorComponent },
      { path: 'contactDPA', component: ContactDpaComponent },
      { path: 'faq', component: QuestionAndAnswerComponent },
      { path: 'verify', component: VerifyComponent },
      { path: 'verify2', component: Verify2Component },
      { path: 'index', component: IndexComponent },

      { path: 'reqNewDocument', component: RequestDocumentComponent },
      { path: 'statusReqNewDocument', component: StatusRequestDocumentComponent },


      { path: 'contact', component: ContactComponent },
      { path: 'contactReport', component: ContactReportComponent },
      { path: 'chatbot', component: ChatbotComponent },
      { path: 'socialMedia', component: SocialMediaMonitorComponent },
      { path: 'report', component: ReportComponent },
      { path: 'allNews', component: AllNewsComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'login', component: LoginComponent },
      { path: 'profile', component: ProfileComponent },

      { path: 'forgotPassword', component: ForgotPasswordComponent },
      { path: 'statusDocument/:id', component: StatusDocumentComponent },
      { path: 'statusTracking', component: StatusTrackingComponent },
      { path: 'refundDeposits', component: RefundDepositsComponent },
      { path: 'aboutUs', component: AboutUsComponent }
    ]
  },
  {
    path: 'news/:id', component: NewsComponent
  },
  { path: 'resetPassword', component: ResetPasswordComponent },
  { path: 'resetpassword', component: ResetPasswordComponent },
  { path: 'loginSocial', component: LoginSocialComponent },
  { path: 'investigate', component: InvestigateComponent },
  { path: 'downloadFile', component: DownloadFileComponent },
  { path: 'login', component: LoginComponent },
  { path: 'Testndid', component: TestndidComponent },
  { path: 'Testndid2', component: Testndid2Component },
  { path: 'singlegatewaywait', component: SinglegatewaywaitComponent },
  { path: 'singlegatewaywait2', component: Singlegatewaywait2Component },
  { path: 'singlegatewaywait3', component: Singlegatewaywait3Component },
  // { path: 'testEncrypt', component: LoginSocialComponent },
  // { path: 'test', component: TestComponent },
];

@NgModule({
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgIdleKeepaliveModule.forRoot(),
    MomentModule,
    HttpModule,
    TranslateModule.forRoot(),
    CoreModule,
    RouterModule.forRoot(
      appRoutes
    )
  ],
  declarations: [AppComponent,
    LoginComponent,
    MainmenuComponent,
    ContactComponent,
    ContactReportComponent,
    ChatbotComponent,
    SocialMediaMonitorComponent,
    ReportComponent,
    SettingComponent,
    NewsComponent,
    SideMainMenuComponent,
    FinancialInstitutionComponent,
    SimulatorComponent,
    RefundComponent,
    ContactDpaComponent,
    QuestionAndAnswerComponent,
    VerifyComponent,
    Verify2Component,
    IndexComponent,
    AllNewsComponent,
    RegisterComponent,
    ThaiDatePipe,
    HighlightSearchPipe,
    ProfileComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    StatusTrackingComponent,
    JwPaginationComponent,
    RefundDepositsComponent,
    StatusDocumentComponent,
    LoginSocialComponent,
    InvestigateComponent,
    DownloadFileComponent,
    AboutUsComponent,
    TestComponent,
    RequestDocumentComponent,
    StatusRequestDocumentComponent,
    TestndidComponent,
    SinglegatewaywaitComponent,
    Testndid2Component,
    Singlegatewaywait2Component,
    Singlegatewaywait3Component],
  providers: [
    AuthService, 
    UtilService, 
    MasterService, 
    AuthGuard, 
    UserService, 
    ApiService, 
    NotiService, 
    PagerService,
    CryptographyService,  
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptorService,
      multi: true
    },
    SocketioService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts